import { render, staticRenderFns } from "./SendInfo.vue?vue&type=template&id=33be3eb4&"
import script from "./SendInfo.vue?vue&type=script&lang=js&"
export * from "./SendInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports